import {
  AfterContentInit,
  Component,
  ElementRef,
  Input,
  NgZone,
  OnDestroy
} from '@angular/core';
import SimpleBar from 'simplebar';

@Component({
  selector: 'vex-scrollbar',
  template: ` <ng-content></ng-content>`,
  styleUrls: ['./vex-scrollbar.component.scss'],
  host: {
    class: 'vex-scrollbar'
  },
  standalone: true
})
export class VexScrollbarComponent implements AfterContentInit, OnDestroy {
  @Input() options?: Partial<any>;

  scrollbarRef?: SimpleBar;

  constructor(
    private _element: ElementRef,
    private zone: NgZone
  ) {}

  ngAfterContentInit() {

    // Define default options
  const defaultOptions = {
    autoHide: false,           // Always show scrollbar
    scrollbarMinSize: 30,      // Minimum scrollbar size
    scrollbarMaxSize: 60,      // Maximum scrollbar size
  };

  // Merge default options with user-provided options
  const mergedOptions = {
    ...defaultOptions,
    ...this.options,           // User options will overwrite defaults if provided
  };
    this.zone.runOutsideAngular(() => {
      this.scrollbarRef = new SimpleBar(
        this._element.nativeElement,
        mergedOptions
      );
    });
      // Apply custom scrollbar color via CSS
  this.setScrollbarColor('#dadada'); 
  }

  ngOnDestroy(): void {
    /**
     * Exists, but not typed in the type definition
     * https://github.com/Grsmto/simplebar/blob/master/packages/simplebar/src/simplebar.js#L903
     */
    if (this.scrollbarRef && (this.scrollbarRef as any).unMount) {
      (this.scrollbarRef as any).unMount();
    }
  }
  // Optional: Function to set custom scrollbar color
setScrollbarColor(color: string): void {
  const scrollbarElement = this._element.nativeElement.querySelector('.simplebar-track.simplebar-vertical');
  if (scrollbarElement) {
    scrollbarElement.style.backgroundColor = color;
  }
}
}
